import { defineMessages } from 'react-intl';

const messages = defineMessages({
  'thankyou.title': {
    defaultMessage: 'Thank you!',
    id: 'aYIUar',
  },
  'thankyou.subtitle': {
    defaultMessage: 'We have received your request',
    id: 'PwjLGb',
  },
  'return-to-estimator': {
    defaultMessage: 'Return to ROI calculator',
    id: 'ezodYQ',
  },
  'details-title': {
    defaultMessage: 'Request details:',
    id: '0L49M8',
  },
  'details-voiceAmount': {
    defaultMessage: 'Clients interactions per month: ',
    id: 'gD5L3F',
  },
  'details-clientsAmount': {
    defaultMessage: 'Interactions over voice/over the phone: ',
    id: 'qiDiGC',
  },
  'saved-per-month': {
    defaultMessage: 'Saved Per Month',
    id: 'OVmAGr',
  },
  'saved-per-year': {
    defaultMessage: 'Saved Per Year',
    id: 'Msjqs6',
  },
  'cookies-interactions-amount': {
    defaultMessage: 'Interactions Amount',
    id: 'aA/nzM',
  },
  'cookie-voice': {
    defaultMessage: 'Voice',
    id: 'mnJYBQ',
  },
  'cookie-montly-savings': {
    defaultMessage: 'Monthly savings',
    id: 'NG+7wf',
  },
  'cookie-yearly-savings': {
    defaultMessage: 'Yearly savings',
    id: 'dGmBmc',
  },
  'labeltext-admin': {
    defaultMessage: 'NA',
    id: 'ef99Fb',
  },
  modeler_desc: {
    defaultMessage: 'NA-modeler-desc',
    id: 'A8GIpI',
  },
  'labeltext-user': {
    defaultMessage:
      'What percentage of those interactions are voice/over the phone?',
    id: '34VMra',
  },
  user_desc: {
    defaultMessage: 'description',
    id: 'OE94n1',
  },
  'invalid-client_interactions': {
    defaultMessage:
      'The amount of client interactions cannot be less than 1000 per month.',
    id: '9yitU2',
  },
  'footnote-one': {
    defaultMessage:
      'The results shown are based on certain assumptions including the cost of a human agent response is US$6.00 via voice, and US$0.50 via digital channel; the calculation is based on USA data. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider watsonx Assistant as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage, configurations, and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual ROI & benefit will vary depending on individual client configurations and conditions.',
    id: '7PKNRN',
  },
  'text-not-in-range': {
    defaultMessage:
      'Your input does not  match the range of values for this calculator. Min: 1,000 and max: 100,000,000. Please connect with one of our experts for more details on how watsonx  Assistant  can help your  business.',
    id: 'mLQO2u',
  },
  'talk-to-expert-button': {
    defaultMessage: 'Contact Us',
    id: 'hZOGLS',
  },
  'estimated-costs-monthly': {
    defaultMessage: 'Estimated monthly savings',
    id: 'Ph+Erw',
  },
  'estimated-costs-yearly': {
    defaultMessage: 'Estimated yearly savings',
    id: 'onnR99',
  },
  'drawer-close': {
    defaultMessage: 'Close',
    id: 'rbrahO',
  },
  'request-quote': {
    defaultMessage: 'Request a quote now',
    id: 'aAghQx',
  },
  'client-interactions': {
    defaultMessage: 'Client interactions: ',
    id: 'wG60ri',
  },
  'main-headline': {
    defaultMessage: 'See how much IBM watsonx Assistant could save you',
    id: '6x4BJI',
  },
  'main-sub-headline': {
    defaultMessage:
      'Please enter the number and type of interactions you see each month to estimate your potential savings.',
    id: 'w6IgMD',
  },
  'label-question-one': {
    defaultMessage: 'How many client interactions do you have each month?',
    id: 'cUxb0t',
  },
  'label-three': {
    defaultMessage:
      'A customer interaction is a single chat or call session where the customer is requesting one or more answers or actions.',
    id: '75fpW7',
  },
  preferred_bp: {
    defaultMessage: 'Preferred IBM Business Partner',
    id: '9Auwhe',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  availableIn: {
    id: 'MyVqne',
    defaultMessage: 'The watsonx ROI Calculator is available in',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
});

export default messages;
